window.Products.HomeDecor.DuvetCoverKing = function() {};
window.Products.HomeDecor.DuvetCoverKing.inherits(window.Products.HomeDecor.DuvetCover);
window.Products.HomeDecor.DuvetCoverKing.has_3d = true;
window.Products.HomeDecor.DuvetCoverKing.id = '86-king';
window.Products.HomeDecor.DuvetCoverKing.saveId = 86;
window.Products.HomeDecor.DuvetCoverKing.slug = 'duvet-cover-king';
window.Products.HomeDecor.DuvetCoverKing.dpi = 150;
window.Products.HomeDecor.DuvetCoverKing.prototype.designObject = 2;